export default __webpack_public_path__ + "static/media/SolidaryandFood.66eba338.png";